import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    shouldDisplayInvoiceList: false,
    shouldDisplaySingleInvoice: false,
    shouldDisplayMainUtilityView: true,
    isTransactionSuccessfullyStarted : false,
    isTransactionSuccessfullyCompleted: false,
    extraInvoiceListData: {},
    transactionId: '',
    isConfirmationDialogOpen: false,
    osheeInvoiceType: '',
    sentFrom: '',
    invoiceList: [],
    singleInvoice: {},
    extraData:[],
    isLoading: false,
    utilityName: '',
    listOfTaxes:[]
};

export const taksatVendoreSlice = createSlice({
    name: 'taksatVendore',
    initialState,
    reducers:{
        displayInvoiceList : (state) => {
            state.shouldDisplayInvoiceList = true
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayMainUtilityView = false
        },
        setSentFrom : (state, action) => 
        {
            state.sentFrom = action.payload
        },
        setExtraInvoiceListData : (state, action) => 
        {
            state.extraInvoiceListData = action.payload
        },
        displaySingleInvoice : (state) => {
            state.shouldDisplaySingleInvoice = true
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = false
        },
        displayMainUtilityView : (state) => 
        {
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = true
        },
        setRequestData : (state, action) => 
        {
            state.requestData = action.payload
        },
        changeConfirmationDialogState: (state) =>
        {
            state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen
        },
        setIsTransactionSuccessfullyStarted: (state, action) => 
        {
            state.isTransactionSuccessfullyStarted = action.payload
        }, 
        setUtilityName: (state, action) => 
        {
            state.utilityName = action.payload
        }, 
        clearUtilitySliceStateForBasicAccount : (state) =>
        {
            state.shouldDisplayInvoiceList = false
            state.shouldDisplaySingleInvoice = true
            state.shouldDisplayMainUtilityView = false
            state.isTransactionSuccessfullyStarted = false
            state.isTransactionSuccessfullyCompleted = false
            state.transactionId = ''
            state.isConfirmationDialogOpen = false
            state.singleInvoice = {}
            state.extraData = []
            state.listOfTaxes = []
            state.isLoading = false
        },
        clearUtilitySliceState: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
             /**/////////////////////////////////////Taksat Vendore Offline /////////////////////////////////////////////////////////////////////////////////////////////////////////// */
             if(action.payload.endpoint === 'TAKSAVENDORE/GetListOfTaxes')
             {
                 state.listOfTaxes = action.payload.response.taxes
             }
             else if(action.payload.endpoint === 'TAKSAVENDORE/StartTransactionTaxes')
                {
                    const invoice = action.payload.response
                    state.transactionId = invoice.transID
                    state.singleInvoice = {
                        'Nr i transaksioneve': invoice.transactionsSummary.NoOfTrans,
                        'Komisioni': invoice.transactionsSummary.TotalFee + ' Leke',
                        'Vlera': invoice.transactionsSummary.NetAmount + ' Leke',
                        'Vlera totale': invoice.transactionsSummary.GrossAmount + ' Leke'
                    }
                    state.isTransactionSuccessfullyStarted = true
                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false
                    
                }
            else if(action.payload.endpoint === 'TAKSAVENDORE/ConfirmTransactionTaxes')
                {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
            })
            
    },
})
export const { displayInvoiceList, displaySingleInvoice, setSentFrom,setOsheeInvoiceType, setExtraInvoiceListData, setIsTransactionSuccessfullyStarted, clearUtilitySliceStateForBasicAccount, displayMainUtilityView, setRequestData, clearUtilitySliceState, changeConfirmationDialogState, setUtilityName } = taksatVendoreSlice.actions;

export const selectTaksatVendoreState = (state) => state.taksatVendore;

export default taksatVendoreSlice.reducer;

